export default "__VITE_ASSET__Bz$7kh7U__"